import { WindPowerIcon } from './WindPowerIcon';

/**
 * author: Google
 * id 4A21CDF6-CF3E-46DB-8A1E-A5F51225DDE3
 * name wind-power
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wind-power.svg
 * tags
 * - Home Automation 
 */
export const WindEnergyIcon = WindPowerIcon;
export default WindEnergyIcon